module.exports = __webpack_public_path__ + "media/brands/AdobeStock_122344884-718f1a5d.jpeg";